import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerDocumentiDoganaliRicevutiModalComponent} from './worker-documenti-doganali-ricevuti-modal';

export const WorkerDocumentiDoganaliRicevutiModalModule: string = ng
    .module('worker-documenti-doganali-ricevuti-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDocumentiDoganaliRicevutiModalComponent', WorkerDocumentiDoganaliRicevutiModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-documenti-doganali-ricevuti-modal/worker-documenti-doganali-ricevuti-modal.module.ts